import NsContent from 'components/common/ns-content/NsContent';
import NsDownload from '@britishgasenergy/react-nucleus/dist/nuc-components/NsDownload';

import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';

export const DirectDebitGuarantee = () => {
  return (
    <>
      <NsContent>
        <h4 data-testid="ddGuaranteeTitle">Direct Debit Guarantee</h4>
        <p>
          By pressing ‘Continue’ you agree that you are authorised to set up a
          Direct Debit for this account. Your prices are lower with Direct
          Debit, so if you move to a different payment method your prices will
          increase.
        </p>
      </NsContent>
      <NsDownload href="/aem6/content/dam/britishgas/documents/Direct-Debit-Guarantee.pdf">
        Direct Debit Guarantee
      </NsDownload>
      <NsCheckboxInput
        name="terms"
        testId="ddGuaranteeTestId"
        options={[
          {
            label: 'I’ve read and understood the Direct Debit Guarantee.',
            value: 'true'
          }
        ]}
        validation={[NsInputterValidations.isRequired]}
      />
    </>
  );
};
